<template>
	<div
		style="width: 100%;height: calc(100vh - 55px);display: flex;align-items: center;overflow-y: scroll;background-color: #f5f5f5;">
		<div style="width: 100%;height: 100%;">
			<div style="background-color: #f5f5f5;" v-for="(listItem,listIndex) in list" :key="listIndex">
				<div v-if="selectName == listItem.name ?selectName == '基础设置':false"
					style="width: 100%;height:calc(100vh - 55px);">
					<div>
						<div class="tabs"
							style="width: 100%;display: flex;align-items: center;justify-content: center;padding-top: 10px;">
							<div v-if="item.name != '其他设置'" @click="clickTab(item.name + index)"
								:style="{backgroundColor: editableTabsValue == (item.name + index)?'#3c429b':'#fff',color: editableTabsValue == (item.name + index)?'#fff':'#000',borderRadius:index == 0 ?'4px 0px 0px 4px':index == listItem.tabList.length- 1?'0px 4px 4px 0px':'0px',borderLeft:index ==0?'solid 1px #242754':'none' }"
								style="width:calc(25% - 10px);text-align: center;cursor: pointer;padding: 4px 0px;font-size: 14px;border-bottom: solid 1px #242754;border-top:solid 1px #242754;border-right:solid 1px #242754;"
								v-for="(item, index) in tabList" :key="item.name + index">
								<div>{{item.name}}</div>
							</div>
						</div>
						<div style="width: 100%;margin-top: 20px;">
							<div style="width: calc(95% + 30px);margin: auto;" v-for="(item, index) in listItem.tabList"
								:key="item.name + index + 'set'">
								<set-layout tabType="all" v-if="item.name == '全站布局' && editableTabsValue == '全站布局0'"
									:dataItem="item.config"></set-layout>
								<set-font v-if="item.name == '字体设置'  && editableTabsValue == '字体设置1'"
									:dataItem="item.config"></set-font>
								<set-layout v-if="item.name == '其他设置' && editableTabsValue == '全站布局0'"
									:dataItem="item.config" tabType="oldOther"></set-layout>
								<temp-center  v-if="item.name == '模板中心' && editableTabsValue == '模板中心3'"
									:dataItem="item.config"></temp-center>
									
								<customization-code  v-if="item.name == '自定义代码' && editableTabsValue == '自定义代码2'"
									:dataItem="item.config"></customization-code>	
								
								<!-- <set-other :fontList="fontList" :fontFamilyName="fontFamilyName"
									v-if="item.name == '其他设置'  && editableTabsValue == '其他设置2'"
									:dataItem="item.config"></set-other> -->
							</div>
						</div>
					</div>
				</div>
				<div style="margin-left: 5px;width: 100%;height:calc(100vh - 55px);background-color: #fff;overflow-y: scroll;"
					v-if="selectName == listItem.name ?selectName == '页眉':false && listItem.data.length > 0">
					<div class="tabs" style="padding: 10px;">
						<div style="width: 100%;margin-top: 10px;">
							<div style="width: 100%;margin: auto;" v-for="(item, index) in listItem.tabList"
								:key="item.name + index + 'set'">
								<set-nav :boxWidth="boxWidth" :itemId="getItemId(listItem.tabList)" :systemConfig="systemConfig"
									v-if="item.name == '导航配置'" :dataList="item"></set-nav>
							</div>
						</div>
					</div>
				</div>
				<div style="margin-left: 5px;width: 100%;height:calc(100vh - 55px);background-color: #fff;"
					v-show="selectName == listItem.name ?selectName == '页脚':false">
					页脚
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import lodash from 'lodash';
	import setLayout from './setLayout.vue'
	import setFont from './setFont.vue'
	import setBg from './setBg.vue'

	import setNav from './setNav.vue'
	import setOther from './setOther.vue'
	import tempCenter from './tempCenter.vue'
	import customizationCode from './customizationCode.vue'
	import {
		getDesignAllSetting
	} from '../../api/all.js'


	function deepMergeArray(target, source, vm = null) {
		const set = vm ? vm.$set.bind(vm) : Vue.set.bind(Vue);

		// 确保目标是数组
		if (!Array.isArray(target)) {
			const newArray = deepClone(source);
			return vm ? Vue.observable(newArray) : newArray;
		}

		// 确保源是数组
		if (!Array.isArray(source)) {
			return target;
		}

		// 合并数组元素
		source.forEach((item, index) => {
			if (index < target.length) {
				// 对应位置元素都存在
				if (typeof item === 'object' && item !== null) {
					// 对象或数组，递归合并
					if (Array.isArray(item)) {
						target[index] = deepMergeArray(target[index], item, vm);
					} else {
						target[index] = deepMergeObject(target[index], item, vm);
					}
				} else {
					// 基本类型，直接覆盖
					set(target, index, item);
				}
			} else {
				// 目标数组较短，添加新元素
				set(target, index, deepClone(item));
			}
		});

		return target;
	}

	/**
	 * 深度合并对象（辅助函数）
	 */
	function deepMergeObject(target, source, vm = null) {
		const set = vm ? vm.$set.bind(vm) : Vue.set.bind(Vue);

		if (typeof target !== 'object' || target === null) {
			return deepClone(source);
		}

		if (typeof source !== 'object' || source === null) {
			return target;
		}

		Object.keys(source).forEach(key => {
			const sourceVal = source[key];
			const targetVal = target[key];

			if (typeof sourceVal === 'object' && sourceVal !== null) {
				if (!targetVal || typeof targetVal !== 'object') {
					set(target, key, Array.isArray(sourceVal) ? [] : {});
				}
				if (Array.isArray(sourceVal)) {
					target[key] = deepMergeArray(targetVal, sourceVal, vm);
				} else {
					target[key] = deepMergeObject(targetVal, sourceVal, vm);
				}
			} else {
				set(target, key, sourceVal);
			}
		});

		return target;
	}

	/**
	 * 安全深拷贝
	 */
	function deepClone(obj) {
		try {
			return JSON.parse(JSON.stringify(obj));
		} catch (e) {
			console.warn('Deep clone failed:', e);
			return Array.isArray(obj) ? [...obj] : {
				...obj
			};
		}
	}

	export default {
		components: {
			setLayout,
			customizationCode,
			setFont,
			setBg,
			setNav,
			setOther,
			tempCenter
		},
		props: {
			all_setting: {
				type: Array,
				default: () => {
					return []
				}
			},

			pageValue: {
				type: String,
				default: ''
			},
			systemConfig: {
				type: Object,
				default: () => {
					return {}
				}
			},
		},

		data() {
			return {
				boxWidth:0,
				tabList: [{
						name: '全站布局'
					},
					{
						name: '字体设置'
					},
					{
						name: '自定义代码'
					},
					{
						name: '模板中心'
					}
				],
				itemId: "",
				selectName: "基础设置",
				editableTabsValue: "全站布局0",
				selectKey: 1,
				list: [{
						name: "基础设置",
						tabList: [{
								name: "全站布局",
								config: {
									bg: {
										setWidth: {
											type: "percentage",
											width: 1200
										},
										bgImg: {
											url: '',
											type: "",
											position: "",
											width: "",
											height: ""
										},
										bgColor: {
											bgColor: '',
										},
										singleBgColor: {
											bgColor: '',
										},
									},
									box: {
										boxBgImg: {
											url: '',
											type: "",
											position: "",
											width: "",
											height: ""
										},
										boxColor: {
											bgColor: '',
										},
										boxSingleBgColor: {
											bgColor: '',
										},
									},
									nav: {
										btoShadow: {
											bgColor: "",
											r: "",
											y: ""
										},
										navSetHeight: {
											height: 120,
											toTop: true
										},
										bg: {
											setWidth: {
												type: "percentage",
												width: 1200
											},
											bgImg: {
												url: '',
												type: "",
												position: "",
												mode: "",
												width: "",
												height: ""
											},
											bgColor: {
												bgColor: '',
											},
											singleBgColor: {
												bgColor: '',
											},
										},
										box: {
											boxBgImg: {
												url: '',
												type: "",
												position: "",
												mode: "",
												width: "",
												height: ""
											},
											boxColor: {
												bgColor: '',
											},
											boxSingleBgColor: {
												bgColor: '',
											},
										},
									},
									foot: {
										topShadow: {
											bgColor: "",
											r: "",
											y: ""
										},
										footerSetHeight: {
											height: ''
										},
										bg: {
											setWidth: {
												type: "percentage",
												width: 1200
											},
											bgImg: {
												url: '',
												type: "",
												position: "",
												mode: "",
												width: "",
												height: ""
											},
											bgColor: {
												bgColor: '',
											},
											singleBgColor: {
												bgColor: '',
											},
										},
										box: {
											boxBgImg: {
												url: '',
												type: "",
												position: "",
												mode: "",
												width: "",
												height: ""
											},
											boxColor: {
												bgColor: '',
											},
											boxSingleBgColor: {
												bgColor: '',
											},
										},
									}
								},
							},
							{
								name: "字体设置",
								config: {
									setColor: {
										color: "#000"
									},
									setFontSize: {
										fontSize: "16"
									},
									setfontFamily: {
										fontFamily: "",
										fontList: [],
										name: "",
										css: ""
									}
								}
							},
							{
								name: "其他设置",
								config: {
									breadcrumb: {
										fontName: "",
										fontCss: "",
										padding: [0, 0, 0, 0],
										margin: [0, 0, 0, 0],
										border: {
											borderRadius: [0, 0, 0, 0],
											borderSize: [0, 0, 0, 0],
											radius: 0,
											type: "solid",
											px: 0,
											color: ""
										},
										type: 'allWidth', // 全宽 allWidth 盒装 box
										typeBoxWidth: 700,
										bgType: "color", // color gradient
										boxBgColor: "color",
										// 盒装
										boxColor: "",
										boxGradient: "",
										// 背景全局
										bgColor: "",
										bgGradient: "",
										// 文字
										titType: "allWidth", // 全宽 allWidth 盒装 box
										titBoxWidth: 700,
										fontSize: 16,
										fontFamily: "",
										isShow: true,
										titPosition: "start" // center left
									},
									globalDialog: {
										bg: {
											bgType: "", // color gradient img
											bgImg: {
												url: '',
												type: "",
												position: "",
												width: "",
												height: ""
											},
											bgGradient: '',
											bgColor: ''
										},
										width: 400,
										height: 600,
										phoneHeight: 400,
										phoneWidth: 300,
										// 是否开启
										isOpen: false,
										// 标题
										title: "",
										// 标题位置
										titPosition: "start", // center left
										color: '#000', // 标题颜色
										fontSize: 16, // 标题字体大小
										fontFamily: "",
										authClose: true,
										// 自动几秒关闭 0
										authCloseTime: 0,
										// 进站几秒打开 0 进站后立即打开
										comeOpenTime: 0,
										padding: [0, 0, 0, 0],
										border: {
											borderRadius: [0, 0, 0, 0],
											borderSize: [0, 0, 0, 0],
											radius: 0,
											type: "solid",
											px: 0,
											color: ""
										},
									}
								}
							},

							

							{
								name: "模板中心",
								config: {}
							},
							{
								name: "自定义代码",
								config: {
									bodyTopCode:"",
									headCode:""
								}
							},

							// {
							// 	name: "选项3",
							// 	config:{}
							// },
							// {
							// 	name: "图标设置",
							// 	config:{}
							// },
							// {
							// 	name: "选项5",
							// 	config:{}
							// }
						]
					},

					{
						name: "页眉",
						tabList: [{
							name: "导航配置",
							data: [],
						}]
					},
					{
						name: "页脚",
						tabList: [{
							name: "底部导航配置",
							data: []
						}]
					},
					{
						name: "test",
					}
				]

			}
		},
		computed: {
			fontList: function() {
				if (this.all_setting.length > 0) {
					let itemSetFont = this.all_setting[0].tabList[1]
					console.log('itemSetFontitemSetFontitemSetFont', itemSetFont)
					return itemSetFont.config.setfontFamily.fontList
				}
			},
			fontFamilyName: function() {
				if (this.all_setting.length > 0) {
					return this.all_setting[0].tabList[1].config.setfontFamily.name
				} else {
					return ''
				}
			}
		},
		watch: {
			list: {
				immediate: true,
				deep: true,
				handler: function(newVal, oldVal) {
					console.log('newVal', newVal)
					this.$emit('changeSetList', newVal)
				}
			},
			all_setting: {
				immediate: true,
				deep: true,
				handler: function(newVal, oldVal) {
					if (newVal) {
						console.log('all_setting', newVal)
						try {
							console.log('newVal[0].tabList[0]',newVal[0].tabList[0])
							if(newVal.length > 0){
								this.boxWidth = parseInt(newVal[0].tabList[0].config.bg.setWidth.width)
								console.log('this.boxWidth ',this.boxWidth )
							}
						}catch(e){
						}
						// this.list = newVal
						
						this.list = deepMergeArray(this.list, lodash.cloneDeep(newVal), this);

						// this.list = lodash.merge(lodash.cloneDeep(newVal),this.list)
						// console.log('this.listthis.list', this.list)

					}
				}
			},
			pageValue: {
				immediate: true,
				handler: function(newVal, oldVal) {
					if (newVal == '11') {
						this.selectName = '页眉'
						this.editableTabsValue = '导航配置0'
					}
					if (newVal == '10') {
						this.selectName = '基础设置'
						this.editableTabsValue = '全站布局0'
					}
				}
			},
		},
		mounted() {
			console.log('all_mountedsetting', this.all_setting)
			// 重新赋值免得下次又有新需求

			// Object.assign()
			// this.list[0].tabList.forEach(localItem=>{
			// 	this.all_setting[0].tabList.forEach(saveItem=>{
			// 		Object.assign()
			// 	})
			// 	// for(let i of saveItem.config){
			// 	// }
			// })
			// if (this.all_setting.length > 0) {
			// 	this.list = lodash.cloneDeep(this.all_setting)
			// }
		},
		methods: {
			getItemId(list) {
				console.log('getItemIdlist', list)
				if (list[0].data.length > 1) {
					return list[0].data[0].id
				}
			},
			async save(e) {
				const loading = this.$loading({
					lock: true,
					text: '请稍后...',
					spinner: 'el-icon-loading',
					background: 'rgba(50, 50, 50, 0.7)'
				});
				console.log('e', e)
				console.log(this.list)
				try {
					let wsid = this.$cookies.get("wsid")
					let data = await getDesignAllSetting({
						data: JSON.stringify(this.list),
						wsid
					})
					this.$message.success(data.data.message)
					loading.close();
				} catch (e) {
					loading.close();
				}
			},
			clickTab(e) {
				this.editableTabsValue = e
				console.log('this.editableTabsValue',this.editableTabsValue)
			},
			ipt(e, field) {
				e[field] = e[field].replace(/\D/g, '')
			},
			changeIpt(e) {
				console.log('e', e)
			}
		}
	}
</script>

<style scoped lang="scss">
	.tabs {
		::v-deep .el-tabs__item {
			height: 34px;
			color: #000000;
			// font-weight: bold;
		}

		::v-deep .is-active {
			color: #242754;
		}

		::v-deep .el-input__inner:focus {
			border: solid 1px #242754;
		}

		::v-deep .el-select .el-input.is-focus .el-input__inner {
			border: 1px solid #242754;
		}

		::v-deep .el-select .el-input__inner:focus {
			border: 1px solid #242754;
		}

		::v-deep .el-select-dropdown__item::after .selected {
			color: #242754;
			background-color: #242754;
		}

		::v-deep .el-scrollbar__view .el-select-dropdown__list {
			color: #8C62FF;
		}

		::v-deep .el-select-dropdown__item {
			color: #242754;
		}
	}
</style>